import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { loginGameBall } from "src/app/gameball";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { TranslateService } from "@ngx-translate/core";
import { EmbryoService } from "../../Services/Embryo.service";
import { HomePageService } from "src/app/Services/home-page.service";

declare global {
    interface Window {
        fcWidget: any;
        FB: any;
    }
}

@Component({
    selector: "embryo-HeaderUserProfileDropdown",
    templateUrl: "./HeaderUserProfileDropdown.component.html",
    styleUrls: ["./HeaderUserProfileDropdown.component.scss"],
})
export class HeaderUserProfileDropdownComponent implements OnInit {
    userData = this.auth.getUser() ? this.auth.getUser() : "";
    lang: string = "";
    isUserGuest: boolean = this.auth.isGuest();
    enteredMenu: boolean = false;
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;
    environmentVariables: any;
    loyaltyData: any;
    productCartList = [];
    productFavoriteList = [];
    productCompareList = [];
    headerTextColor: any;
    headerIconsColor: any;
     changeIconFill:boolean = true;

    constructor(
        public router: Router,
        private auth: LoginUsersService,
        private embryoService: EmbryoService,
        private translate: TranslateService,
        private loginSer: LoginUsersService,
        private confgServ: StaticPagesService,
        private route: ActivatedRoute,
        private homePageService: HomePageService
    ) {
        this.getInitilizingData();

        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            translate.setDefaultLang(lang);
        });
        auth.getUserDataEmit().subscribe((data) => {
            this.userData = data;
            this.isUserGuest = this.auth.isGuest();
            if (
                !this.userData?.is_guest &&
                !this.environmentVariables?.GUEST_CAN_VIEW_PRICES_TRIGGER
            ) {
                this.environmentVariables.GUEST_CAN_VIEW_PRICES = true;
            } else if (
                this.userData?.is_guest &&
                !this.environmentVariables?.GUEST_CAN_VIEW_PRICES_TRIGGER
            ) {
                this.environmentVariables.GUEST_CAN_VIEW_PRICES = false;
            }
            this.confgServ.setenvConfig(this.environmentVariables);
        });
    }
    getLoyalty() {
        this.embryoService.getLoyalty().subscribe((res: any) => {
            this.loyaltyData = res.data;
            this.embryoService.setLoyaltyDataEmit(this.loyaltyData);
        });
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.headerTextColor = res.HEADER_TEXT_COLOR;
            this.headerIconsColor = res.HEADER_ICONS_FILL_COLOR;
        });
        if (
            this.environmentVariables?.CHAT_SUPPORT_PROVIDER == "fresh-chat" &&
            this.environmentVariables?.FRESH_CHAT_TOKEN &&
            this.environmentVariables?.FRESH_CHAT_TOKEN?.length > 0
        ) {
            this.initialFreshChatScript();
        } else if (
            this.environmentVariables?.CHAT_SUPPORT_PROVIDER == "messenger" &&
            this.environmentVariables?.MESSENGER_CHAT_TOKEN &&
            this.environmentVariables?.MESSENGER_CHAT_TOKEN?.length > 0 &&
            ((this.isUserGuest &&
                this.environmentVariables?.ENABLE_CHAT_SUPPORT_FOR_GUEST) ||
                !this.isUserGuest)
        ) {
            this.enableMessengerChat();
        }
        this.homePageService.getInitData().subscribe((res) => {
            if (res?.profile) {
                if (this.environmentVariables?.LOYALTY_PROVIDER == "sadhan" && (this.userData.branch || this.userData.area)) {
                    this.getLoyalty();
                }
            }
        });
    }

    ngOnInit() {
        this.isUserGuest = this.auth.isGuest();
        this.auth.userEmit.subscribe((data) => {
            if (data) {
                if (!this.auth.isGuest()) {
                    this.isUserGuest = false;
                    this.auth.setToken(data.token);
                }

                this.userData = data !== this.auth.getToken() ? data : "";
                if (
                    this.userData.name &&
                    this.userData.phone &&
                    this.userData.phone_verified == 1 &&
                    this.environmentVariables?.LOYALTY_PROVIDER == "gameBall"
                ) {
                    // loginGameBall();
                    const body = document.querySelector("body");
                    if (body && body.classList.contains("notVerifiedPhone")) {
                        body.classList.remove("notVerifiedPhone");
                    }
                } else if (!this.userData.phone) {
                    const body = document.querySelector("body");
                    if (body) {
                        body.className = "noPhoneData";
                    }
                } else if (
                    this.userData.phone &&
                    this.userData.phone_verified != 1
                ) {
                    const body = document.querySelector("body");
                    if (body) {
                        body.className = "notVerifiedPhone";
                    }
                }
            } else {
                this.isUserGuest = true;
            }

            if (
                this.environmentVariables?.CHAT_SUPPORT_PROVIDER ==
                    "fresh-chat" &&
                this.environmentVariables?.FRESH_CHAT_TOKEN &&
                this.environmentVariables?.FRESH_CHAT_TOKEN?.length > 0 &&
                !this.isUserGuest
            ) {
                this.setFreshChat();
            } else if (
                this.environmentVariables?.CHAT_SUPPORT_PROVIDER ==
                    "fresh-chat" &&
                this.environmentVariables?.FRESH_CHAT_TOKEN &&
                this.environmentVariables?.FRESH_CHAT_TOKEN?.length > 0 &&
                this.isUserGuest &&
                this.environmentVariables?.ENABLE_CHAT_SUPPORT_FOR_GUEST
            ) {
                this.setFreshChat();
            } else if (
                this.environmentVariables?.CHAT_SUPPORT_PROVIDER ==
                    "messenger" &&
                this.environmentVariables?.MESSENGER_CHAT_TOKEN &&
                this.environmentVariables?.MESSENGER_CHAT_TOKEN?.length > 0 &&
                !this.isUserGuest
            ) {
                this.enableMessengerChat();
            } else if (
                this.environmentVariables?.CHAT_SUPPORT_PROVIDER ==
                    "messenger" &&
                this.environmentVariables?.MESSENGER_CHAT_TOKEN &&
                this.environmentVariables?.MESSENGER_CHAT_TOKEN?.length > 0 &&
                this.isUserGuest &&
                this.environmentVariables?.ENABLE_CHAT_SUPPORT_FOR_GUEST
            ) {
                this.enableMessengerChat();
            } else {
                this.deleteMessenger();
                window.fcWidget?.user.clear();
                window.fcWidget?.destroy();
            }
        });

        this.lang = localStorage.getItem("lang") || "en";
        this.translate.setDefaultLang(this.lang);
    }

    enableFreshChat() {
        if (
            this.environmentVariables?.CHAT_SUPPORT_PROVIDER == "fresh-chat" &&
            this.environmentVariables?.FRESH_CHAT_TOKEN &&
            this.environmentVariables?.FRESH_CHAT_TOKEN?.length > 0
        )
            this.setFreshChat();
    }

    deleteMessenger() {
        let fbRoot = document.getElementById("fb-root");
        fbRoot?.classList.add("d-none");
    }

    enableMessengerChat() {
        // if (!document.getElementById("fb-root")) {
        var isCustomerChatExist =
            document.getElementsByClassName("fb-customerchat");
        if (isCustomerChatExist.length > 0) {
            // will do nothing
        } else {
            const script = document.createElement("script");
            script.id = "fb-script";
            script.text = `window.fbAsyncInit = function() {
          FB.init({
            xfbml: true,
            version: 'v13.0'
          });
        };
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));`;
            let chatDiv = document.createElement("div");
            chatDiv.className = "fb-customerchat";
            chatDiv.id = "fb-customer-chat";
            chatDiv.setAttribute(
                "page_id",
                this.environmentVariables.MESSENGER_CHAT_TOKEN
            );
            chatDiv.setAttribute(
                "theme_color",
                this.environmentVariables.WEB_BRAND_COLOR
            );
            chatDiv.setAttribute("attribution", "biz_inbox");
            let chatDivContainer = document.createElement("div");
            chatDivContainer.id = "fb-root";
            document
                .getElementsByTagName("body")[0]
                .appendChild(chatDivContainer);
            document.getElementsByTagName("body")[0].appendChild(chatDiv);
            document.getElementsByTagName("body")[0].appendChild(script);
        }

        // } else {
        //     let fbRoot = document.getElementById("fb-root");
        //     fbRoot?.classList.remove("d-none");
        // }
    }

    initialFreshChatScript() {
        const script = document.createElement("script");
        script.src = "https://wchat.freshchat.com/js/widget.js";
        const body = document.getElementsByTagName("body");
        body[0].appendChild(script);

        script.onload = () => {
            if (
                this.environmentVariables?.ENABLE_CHAT_SUPPORT_FOR_GUEST ||
                !this.isUserGuest
            ) {
                this.enableFreshChat();
            }
            // setTimeout(() => {
            //     console.clear();
            // }, 1000);
        };
    }

    setFreshChat() {
        var freshChat;
        if (localStorage.getItem("auth_user_crocs")) {
            window.fcWidget.user.clear();
            freshChat = {
                token: this.environmentVariables?.FRESH_CHAT_TOKEN,
                host: "https://wchat.freshchat.com",
                externalId: JSON.parse(
                    localStorage.getItem("auth_user_crocs") || "{}"
                ).id,
                firstName: JSON.parse(
                    localStorage.getItem("auth_user_crocs") || "{}"
                ).name,
                lastName: JSON.parse(
                    localStorage.getItem("auth_user_crocs") || "{}"
                ).last_name,
                user: {
                    firstName: JSON.parse(
                        localStorage.getItem("auth_user_crocs") || "{}"
                    ).name,
                    lastName: JSON.parse(
                        localStorage.getItem("auth_user_crocs") || "{}"
                    ).last_name,
                    email: JSON.parse(
                        localStorage.getItem("auth_user_crocs") || "{}"
                    ).email,
                    phone: JSON.parse(
                        localStorage.getItem("auth_user_crocs") || "{}"
                    ).phone,
                },
            };
        } else {
            window.fcWidget.user.clear();
            freshChat = {
                token: this.environmentVariables?.FRESH_CHAT_TOKEN,
                host: "https://wchat.freshchat.com",
            };
        }
        window.fcWidget.init(freshChat);
        // setTimeout(() => {
        //     console.clear();
        // }, 1000);
    }
    logIn() {
        this.router.navigate([`/${this.lang}/session/signin`]);
    }

    logOut() {
        localStorage.removeItem("compareItems");
        localStorage.removeItem("wishListItems");
        this.embryoService.favouritesListSub.next([]);
        this.embryoService.compareListSub.next([]);
        this.embryoService.guestProductsCart = [];
        this.embryoService.productCartSub.next([]);
        this.embryoService.setLoyaltyDataEmit(null);
        this.auth.logOut();
        this.isUserGuest = true;
        this.userData.is_guest = true;
        document.getElementById("html")?.classList.remove("admin-panel");
        this.router.navigate(["/" + this.lang + "/session/signin"], {
            queryParams: { returnUrl: window.location.pathname },
        });
        // this.embryoService.store([]);
        var initalizePrams: any = {};
        this.homePageService
            .getInitializationsData(initalizePrams)
            .subscribe((res: any) => {
                this.auth.setUserDataEmit(res.data?.profile);
                this.auth.setToken(res.data?.profile?.token);
                this.homePageService.setInitData(res.data);
                localStorage.setItem(
                    "auth_user_crocs",
                    JSON.stringify(res.data?.profile)
                );
                this.auth.userEmit.next(res.data?.profile);
            });
        // this.userData = "";
    }

    toggleMenu(event: any, open: any) {
        if (open) {
            event.stopPropagation();
            this.enteredMenu = false;
            this.menuTrigger?.openMenu();
        } else {
            setTimeout(() => {
                if (!this.enteredMenu) {
                    this.menuTrigger.closeMenu();
                }
            }, 150);
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }

    saveSnapShot() {
        this.loginSer.loginRoute = this.router.url;
    }

    favorite() {
        this.router.navigate(["/" + this.lang + "/favorites"]);
    }
    wallet() {
        this.router.navigate(["/" + this.lang + "/account/wallet-history"]);
    }
}
